import React from "react";
import { Route, Routes } from "react-router-dom";

import ImportationsPage from "@/components/screens/ImportationsPage";
import ImportDetails from "@/components/screens/ImportDetails";
import { IMPORTATION_DETAILS_MESSAGES } from "@/messages/importationDetails/importation-details.messages";
import { IMPORTATIONS_MESSAGES } from "@/messages/importations/importations.messages";

const ImportsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<ImportationsPage messages={IMPORTATIONS_MESSAGES} />} />
      <Route
        path="/details/:importProcessId/:lang"
        element={<ImportDetails messages={IMPORTATION_DETAILS_MESSAGES} />}
      />
      <Route path="/" element={<ImportationsPage messages={IMPORTATIONS_MESSAGES} />} />
    </Routes>
  );
};

export default ImportsPage;
